export const apiGifts = {
  fetchGifts: async (axiosPrivate, setLoading) => {
    try {
      setLoading?.(true);
      const response = await axiosPrivate.get('/gifts');

      return response.data.data;
    } catch (error) {
      console.error('❌ Ошибка при загрузке подарков:', error);
      return [];
    } finally {
      setLoading?.(false);
    }
  },
  fetchMyGifts: async (axiosPrivate, setLoading) => {
    try {
      setLoading?.(true);
      const response = await axiosPrivate.get('/gifts/my');

      return response.data.data
    } catch (error) {
      console.error('[apiGifts] Ошибка при загрузке подарков:', error);
      return [];
    } finally {
      setLoading?.(false);
    }
  },
  fetchGiftsById: async (axiosPrivate, setLoading, userId) => {
    try {
      setLoading?.(true);
      const response = await axiosPrivate.get(`/gifts/${userId}`);

      return response.data.data;
    } catch (error) {
      console.error('[apiGifts] Ошибка при загрузке подарков:', error);
      return [];
    } finally {
      setLoading?.(false);
    }
  },
  fetchBuyGift: async (axiosPrivate, setLoading, giftId) => {
    setLoading?.(true);
    try {
      const buyResponse = await axiosPrivate.post('/gifts/buy', {
        giftId,
      });
      return {
        coins: buyResponse.data.data.wallet.coins || 0,
      };
    } catch (error) {
      console.error('[apiGifts] Ошибка при покупке подарка:', error);
      return error.response?.data?.message || 'Ошибка при покупке подарка';
    } finally {
      setLoading?.(false);
    }
  },
  hasSentGift: async (axiosPrivate, userId) => {
    try {
      return await axiosPrivate.get(`/gifts/${userId}/has-sent`);
    } catch (error) {
      console.error('[hasSentGift] Ошибка при загрузке:', error);
      throw error;
    }
  },
  sendGift: async (axiosPrivate, { recipientId, giftId }) => {
    try {
      return await axiosPrivate.post(`/gifts/send`, { recipientId, giftId });
    } catch (error) {
      console.error('[sendGift] Ошибка при загрузке:', error);
      throw error;
    }
  },
};
